import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import React from "react";
import { isMobileOnly } from "react-device-detect";
import HeaderApp from "../common/Header";
import { NavBar } from "../common/mobile/header";

const AppLayout = ({ children }) => {
  return (
    <Layout>
      {isMobileOnly ? <NavBar /> : <HeaderApp />}
      <Content>{children}</Content>
      {/* <Footer>Footer</Footer> */}
    </Layout>
  );
};

export default AppLayout;
